<template>
  <div v-if="show" class="loadingModal">
    <img src="./loading.gif" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.loadingModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000000;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 80px;
    height: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loadingModal.vue